// import Vue from 'vue'
// import store from '..'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import moment from 'moment'

export default {
  namespaced: true,
  state () {
    return {
    }
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    write ({ commit }, payload) {
      return new Promise((resolve) => {
        var user = firebase.auth().currentUser
        if (user) {
          var database = firebase.database()
          var m = moment(payload.date)
          var ref = database.ref('/logs/' + m.format('YYYY/MM/DD'))
          ref.push({
            uid: user.uid,
            date: m.format(),
            body: payload.body
          }).then(function (response) {
            if (response) {
              console.log(response)
            }
            resolve()
          })
        } else {
          resolve()
        }
      })
    }
  }
}
